import { doneCallbacks } from "../../components/presence.mjs";
function isPresent(visualElement) {
  return !doneCallbacks.has(visualElement.current);
}
export {
  isPresent
};
